// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import i18n from './lang'

// 设置 js中可以访问 $cdn
import { $cdn } from '@/config'
Vue.prototype.$cdn = $cdn

// 全局引入按需引入UI库 vant
import '@/plugins/vant'
// 引入全局样式
import '@/assets/css/index.scss'
// 移动端适配s
import 'amfe-flexible'

// filters
import './filters'

import { Step, Steps, Field, Checkbox, CheckboxGroup, Icon, Toast, Overlay, Dialog, PasswordInput, NumberKeyboard, ActionSheet, Popup, Swipe, SwipeItem } from 'vant'
// import { StripePlugin } from '@vue-stripe/vue-stripe'
import { pk } from '@/config'


import { version } from '../package.json'
Vue.prototype.$version = version



import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAHYv371jSzz--0LwBsXsOKAYPwCiZzJww",
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});
// const options = {
//   pk,
//   testMode: process.env.VUE_APP_ENV !== 'production', // Boolean. To override the insecure host warning
//   // stripeAccount: process.env.STRIPE_ACCOUNT,
//   apiVersion: '2020-08-27'
//   // locale: process.env.LOCALE
// }
// Vue.use(StripePlugin, options)
Vue.config.productionTip = false
Vue.use(Step).use(Steps).use(Field).use(Checkbox).use(CheckboxGroup).use(Icon).use(Toast).use(Overlay).use(Dialog).use(PasswordInput).use(NumberKeyboard).use(ActionSheet).use(Popup).use(Swipe).use(SwipeItem)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    this.setRemUnit();
    window.addEventListener('resize', this.setRemUnit);
    window.addEventListener('pageshow', this.setRemUnit);
  },
  methods: {
    setRemUnit() {
      const html = document.querySelector('html');
      if (!html) return;

      const width = html.offsetWidth;
      const rem = width / 7.5;
      html.style.fontSize = `${rem}px`;
    }
  }
})
